import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import LoadingSpinner from './components/ui/LoadingSpinner';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const Search = lazy(() => import('./pages/Search'));
const MovieDetail = lazy(() => import('./pages/MovieDetail'));
const Anime = lazy(() => import('./pages/Anime'));
const TVSeries = lazy(() => import('./pages/TVSeries'));
const Movies = lazy(() => import('./pages/Movies'));
const Genre = lazy(() => import('./pages/Genre'));

function App() {
    return (
        <ThemeProvider>
            <Layout>
                <Suspense fallback={<LoadingSpinner />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/search" element={<Search />} />
                        <Route path="/movie/:id" element={<MovieDetail />} />
                        <Route path="/anime" element={<Anime />} />
                        <Route path="/tv-series" element={<TVSeries />} />
                        <Route path="/movie" element={<Movies />} />
                        <Route path="/genre/:genreId" element={<Genre />} />
                    </Routes>
                </Suspense>
            </Layout>
        </ThemeProvider>
    );
}

export default App;
